import React from 'react';
import { FormGroup, FormText } from 'reactstrap';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import FormItem from '../../../../common/forms/FormItem';
import Select from '../../../../common/forms/select/Select';
import {
  BAGGAGE_MANIFEST_ACTIONS,
  REPORT_ISSUE_OPTIONS,
} from '../../../../../config/constants';
import { isRequired } from '../../../../../utils/validators';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';

const BaggageManifestDismissalSection = ({
  actionValue,
  saveButtonDisabled,
}) => {
  const renderReportIssueFields = actionValue &&
    actionValue.value === BAGGAGE_MANIFEST_ACTIONS.REPORT_ISSUE.value && (
      <>
        <FormGroup row>
          <FormItem label="Tipo de Problema" required>
            <Field
              name="reportIssueType"
              component={Select}
              validate={[isRequired]}
              options={Object.values(REPORT_ISSUE_OPTIONS).map(
                ({ value, label, isIncident }) => ({
                  value,
                  label,
                  isIncident,
                }),
              )}
            />
          </FormItem>
        </FormGroup>
      </>
    );

  return (
    <>
      <FormGroup row>
        <FormItem label="Acción" required>
          <Field
            name="action"
            component={Select}
            options={[
              BAGGAGE_MANIFEST_ACTIONS.REPORT_ISSUE,
              BAGGAGE_MANIFEST_ACTIONS.DELIVER,
              BAGGAGE_MANIFEST_ACTIONS.DISMISS,
            ]}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {renderReportIssueFields}
      <FormGroup row>
        <FormItem
          label="Comentario"
          required={
            actionValue &&
            actionValue.value !== BAGGAGE_MANIFEST_ACTIONS.DELIVER.value
          }
        >
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            placeholder="Comentario"
            validate={
              actionValue &&
              actionValue.value !== BAGGAGE_MANIFEST_ACTIONS.DELIVER.value
                ? [isRequired]
                : []
            }
          />
          {actionValue &&
            actionValue.value === BAGGAGE_MANIFEST_ACTIONS.DELIVER.value && (
              <FormText>
                El comentario es opcional al entregar equipajes
              </FormText>
            )}
        </FormItem>
      </FormGroup>
      <FormFooter saveButtonDisabled={saveButtonDisabled} />
    </>
  );
};

BaggageManifestDismissalSection.propTypes = {
  actionValue: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  saveButtonDisabled: PropTypes.bool,
};

BaggageManifestDismissalSection.defaultProps = {
  actionValue: undefined,
  saveButtonDisabled: false,
};

export default BaggageManifestDismissalSection;
